module.exports = __webpack_public_path__ + "static/img/hamburger.6e6226a3.svg";